import React, { Component } from 'react';
import { connect } from 'react-redux';
import './no-resultados.css';
import { withTranslation } from 'react-i18next';
import FormularioConsulta from './layout-consulta/formulario-consulta';
import GeoApi from '../../api/destinations';

class NoResultados extends Component {
  constructor(props) {
    super(props);
    this.state = {
      destinoBuscado: undefined,
    };
  }

  componentDidMount() {
    this.getDestinationSearched();
  }

  getDestinationSearched = () => {
    const url = new URL(window.location.href);
    const path = url.pathname;
    const pathParts = path.split('/');

    try {
      GeoApi.getCityByCode(pathParts[4]).then((res) => {
        this.setState({
          destinoBuscado: res.name,
        });
      });
    } catch (e) {
      this.setState({
        destinoBuscado: pathParts[4],
      });
    }
  }

  render() {
    const { t } = this.props;
    const { application } = this.props;

    return (
      <>
        {/* { application.applicationId === '1' && this.vueloMasHotel()} */}
        <FormularioConsulta />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  application: state.applicationState,
});

export default connect(mapStateToProps, null)(withTranslation(['layout'])(NoResultados));
